export const NavbarLinks = [
  {
    title: "Home",
    path: "/home",
  },
  {
    title: "Catalog",
  },
  {
    title: "About Us",
    path: "/about",
  },
  {
    title: "Contact Us",
    path: "/contact",
  },
];
